
























































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import WordDialog from '@/components/WordDialog.vue';
import update from './mixins/update';
import { DictionaryCategory, DictionaryCategories, dictionary, DictionaryEntry } from './dictionary';

@Component({
  name: 'App',
  components: {
    WordDialog
  },
  mixins: [update]
})
export default class AppComponent extends Vue {

    private drawer!: boolean;
    private lastOverlayWord!: DictionaryEntry | undefined;

    private get overlayWord() {
      if (this.$route.hash.length <= 1) {
        return this.lastOverlayWord;
      }
      const wordId = this.$route.hash.substr(1);

      return this.lastOverlayWord = dictionary.find(entry => entry.id === wordId);
    }

    private get categories() {
      return DictionaryCategories
    }

    private get category() {
      return this.$route.params.category? 
        DictionaryCategories[this.$route.params.category as DictionaryCategory] : undefined;
    }

    private data() {
      return {
        drawer: false
      }
    }

}
